import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";
import { AssetsService } from "app/services/AssetsService";
import { CardAndTextWrapper, HomePageCard, Image, UnderCardText } from "../style";
import type { SolutionCardProps } from "../types";

export const SolutionCard = ({
    imageUrl,
    onSolutionClick,
    solutionUnderCardText = "modal.default.homepage.card.hover.text",
}: SolutionCardProps) => {
    const translate = useTranslation();

    return (
        <CardAndTextWrapper>
            <HomePageCard onClick={onSolutionClick}>
                <Image src={AssetsService.assetUrl(imageUrl)} />
            </HomePageCard>
            <UnderCardText>{translate(solutionUnderCardText)}</UnderCardText>
        </CardAndTextWrapper>
    );
};
